<div class="dropdown">
  <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
    <li *ngFor="let item of currencies">
      <a [id]="item.name" class="dropdown-item" href="javascript:void(0)" (click)="setCurrency(item.name)">{{item.name}} - {{item.description}}</a>
    </li>
  </ul>
</div>